// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loadDataOptions {\n    margin: 4px;\n}", "",{"version":3,"sources":["webpack://./src/components/util/table-splitter-ui/src/components/LoadDataButton.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf","sourcesContent":[".loadDataOptions {\n    margin: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
